// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3vkkO","label":"SetPasswdForm_label__3uR2u"};